// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportsPageContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f1f7ff;
}

.chartCont {
    display: flex;
    margin: 50px;
    flex-direction: column;
    align-items: center;
}

.report-btn {
    margin: 20px;
    background-image: linear-gradient(to right, #6bc1ef 0%, #3762f0 51%, #368cdc 100%);
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: none;
    font-weight: 500;
    font-size: 12pt;
    color: #ffffff;
    width: 150px;
}

.totalAmountContainer {
    display: flex;
    padding: 30px 50px 30px 50px;
    border-radius: 10px;
    text-align: center;
    font-weight: 500;
    font-size: 16pt;
    background-color: #ffffff;
    box-shadow: 0px 4px 20px 0px #d8d8d8;
    flex-direction: column;
    align-items: center;
    margin: 20px;

}


.totalAmountTitle {
    font-weight: 500;
    font-size: 15pt;
}

.totalAmount {
    margin: 5px;
    border-radius: 10px;
    text-align: center;
    border: none;
    width: -moz-fit-content;
    width: fit-content;
    font-weight: 700;
    font-size: 35pt;
    color: #3762f0;
}

.report-btn-cont {
    display: flex;
}


.reportsTableContainer {
    margin: 20px;
    display: flex;
    align-items: center;
}

.reportsTableContainer table {
    width: 100%;
    border-collapse: collapse;
}

.reportsTableContainer th,
.reportsTableContainer td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}

.reportsTableContainer th {
    background-color: #f4f4f4;
}

.reportsTableContainer {
    position: relative;
    padding: 20px;
}

.closeTableBtn {
    display: block;
    margin: 10px auto;
    padding: 8px 16px;
    font-size: 16px;
    background-color: #f44336;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.closeTableBtn:hover {
    background-color: #c62828;
}

.chartCont {
    margin-top: 20px;
}

.managmentTitle {
    font-weight: 700;
    margin-bottom: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    width: 20%;
    padding: 8px;

}

.reportsDetailsContainer {
    background-color: #ffffff;
    padding: 0px 40px 40px 40px;
    border-radius: 8px;
    direction: rtl;
    height: -moz-fit-content;
    height: fit-content;
    width: -moz-fit-content;
    width: fit-content;
    margin: 120px 50px 50px 50px;
}

.contentReportCont {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 50px;
}

.tableStyleCont {
    display: flex;
    flex-direction: column;
}

.excel-btn {
    padding: 10px 20px 10px 20px;
    border-radius: 100px;
    background-color: white;
    border: 1px solid #11612f;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    font-size: 10pt;
    font-weight: 600;
}

.excel-btn:hover {
    background-color: #beedd0;

}

.allReportsCont {
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportsPage/ReportsPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;;AAEhB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,YAAY;;AAEhB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".ReportsPageContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background-color: #f1f7ff;\r\n}\r\n\r\n.chartCont {\r\n    display: flex;\r\n    margin: 50px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.report-btn {\r\n    margin: 20px;\r\n    background-image: linear-gradient(to right, #6bc1ef 0%, #3762f0 51%, #368cdc 100%);\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    border: none;\r\n    font-weight: 500;\r\n    font-size: 12pt;\r\n    color: #ffffff;\r\n    width: 150px;\r\n}\r\n\r\n.totalAmountContainer {\r\n    display: flex;\r\n    padding: 30px 50px 30px 50px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    font-weight: 500;\r\n    font-size: 16pt;\r\n    background-color: #ffffff;\r\n    box-shadow: 0px 4px 20px 0px #d8d8d8;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin: 20px;\r\n\r\n}\r\n\r\n\r\n.totalAmountTitle {\r\n    font-weight: 500;\r\n    font-size: 15pt;\r\n}\r\n\r\n.totalAmount {\r\n    margin: 5px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    border: none;\r\n    width: fit-content;\r\n    font-weight: 700;\r\n    font-size: 35pt;\r\n    color: #3762f0;\r\n}\r\n\r\n.report-btn-cont {\r\n    display: flex;\r\n}\r\n\r\n\r\n.reportsTableContainer {\r\n    margin: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.reportsTableContainer table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.reportsTableContainer th,\r\n.reportsTableContainer td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n}\r\n\r\n.reportsTableContainer th {\r\n    background-color: #f4f4f4;\r\n}\r\n\r\n.reportsTableContainer {\r\n    position: relative;\r\n    padding: 20px;\r\n}\r\n\r\n.closeTableBtn {\r\n    display: block;\r\n    margin: 10px auto;\r\n    padding: 8px 16px;\r\n    font-size: 16px;\r\n    background-color: #f44336;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.closeTableBtn:hover {\r\n    background-color: #c62828;\r\n}\r\n\r\n.chartCont {\r\n    margin-top: 20px;\r\n}\r\n\r\n.managmentTitle {\r\n    font-weight: 700;\r\n    margin-bottom: 50px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 20%;\r\n    padding: 8px;\r\n\r\n}\r\n\r\n.reportsDetailsContainer {\r\n    background-color: #ffffff;\r\n    padding: 0px 40px 40px 40px;\r\n    border-radius: 8px;\r\n    direction: rtl;\r\n    height: fit-content;\r\n    width: fit-content;\r\n    margin: 120px 50px 50px 50px;\r\n}\r\n\r\n.contentReportCont {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 50px;\r\n}\r\n\r\n.tableStyleCont {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.excel-btn {\r\n    padding: 10px 20px 10px 20px;\r\n    border-radius: 100px;\r\n    background-color: white;\r\n    border: 1px solid #11612f;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    float: left;\r\n    font-size: 10pt;\r\n    font-weight: 600;\r\n}\r\n\r\n.excel-btn:hover {\r\n    background-color: #beedd0;\r\n\r\n}\r\n\r\n.allReportsCont {\r\n    display: flex;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
